<div class="row form-row" [hidden]="hideTypes">
  <div class="col-sm-12">
    {{ 'affiliation.affcode-mass-add.affcode-type' | translate | titlecase }}
  </div>
</div>
<div class="row form-row" [hidden]="hideTypes">
  <div class="col-sm-12">
    <select [(ngModel)]="selectedAffCodeTypeId" class="form-control" (ngModelChange)="onAffCodeTypeChange($event)">
      <option value="">{{ 'common.none' | translate | titlecase }}</option>
      <option
        *ngFor="let affCodeType of affCodeTypes"
        [value]="affCodeType.AffCodeTypeID"
        [selected]="affCodeType.AffCodeTypeID == selectedAffCodeTypeId ? true : null"
      >
        {{ affCodeType.AffCodeType }}
      </option>
    </select>
  </div>
</div>
<div class="row form-row">
  <div class="col-sm-12">
    {{ 'affiliation.affcode-mass-add.affcode' | translate | titlecase }}
  </div>
</div>
<div class="row form-row">
  <div class="col-sm-12">
    <select required [(ngModel)]="selectedAffCode" class="form-control" (ngModelChange)="onAffCodeChange($event)">
      <option *ngFor="let affCode of affCodes" [value]="affCode.AffCode" [selected]="affCode.AffCode == selectedAffCode ? true : null">
        {{ affCode.AffCode }}
      </option>
    </select>
  </div>
</div>
<div class="row form-row">
  <div class="col-sm-12" *ngIf="showButtons == true">
    <button app-add-button (onClick)="addAffCodes()"></button>
    <button icon="pi pi-ban" pButton type="button" class="btn btn-default" (click)="cancel()">
      {{ 'common.cancel' | translate | titlecase }}
    </button>
  </div>
</div>
